import { render, staticRenderFns } from "./kpsrActionDetail.vue?vue&type=template&id=2b373264"
import script from "./kpsrActionDetail.vue?vue&type=script&lang=js"
export * from "./kpsrActionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b373264')) {
      api.createRecord('2b373264', component.options)
    } else {
      api.reload('2b373264', component.options)
    }
    module.hot.accept("./kpsrActionDetail.vue?vue&type=template&id=2b373264", function () {
      api.rerender('2b373264', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kpsr/action/kpsrActionDetail.vue"
export default component.exports